/**
 * Região do planeta nas engrenagens planetárias.
 */
const PLANET = "PLANET";

/**
 * Região do Anel nas engrenagens planetárias.
 */
const RING = "RING";

/**
 * Região do Sol nas engrenagens planetárias.
 */
const SUN = "SUN";

export default {
	SUN, RING, PLANET
};